const bodyScrollLock = require('body-scroll-lock');

$(document).on('click', '.bn_commerce-balance__fire.dynamic', function () {
    let url = '/account/commerce/balance/sidebar?id=' + $(this).attr('data-key');

    getSidebarData(url);
})

$(document).on('click', '.bn_commerce-stat__fire', function () {
    let url = '/account/commerce/stat/sidebar?id=' + $(this).attr('data-key');

    getSidebarData(url);
})

$(document).on('click', '.bn_commerce-balance__fire.static', function () {
    openPopup(false);
})

function openPopup(dynamic = true) {
    let element = document.querySelector('.bn_commerce-stat__sidebar-scroll');

    bodyScrollLock.disableBodyScroll(element, {reserveScrollBarGap: true});

    if (dynamic) {
        $('.bn_commerce-stat__sidebar.dynamic').addClass('open');
    } else {
        $('.bn_commerce-stat__sidebar.static').addClass('open');
    }

    $('body').addClass('modal-open');
}

function closeSidebar () {
    $('.bn_commerce-stat__sidebar').removeClass('open');

    bodyScrollLock.clearAllBodyScrollLocks();

    $('body').removeClass('modal-open');
}

$(document).on('click', '.bn_commerce-stat__sidebar-header-button', function () {
    closeSidebar();
});

$(document).on('click', '.bn_commerce-stat__sidebar-layout', function (event) {
    if ($(event.target).closest('.bn_commerce-stat__sidebar-wrapper').length) return;

    if (!$(this).parents('.bn_commerce-stat__sidebar').hasClass('open')) return;

    closeSidebar();
});

function getSidebarData(url) {
    $.ajax({
        'type': 'GET',
        'url': url,
        'beforeSend': function () {
            $('.bn_commerce-stat__sidebar.dynamic').html('');
        },
        'success': function (data) {
            $('.bn_commerce-stat__sidebar.dynamic').append(data);

            openPopup();

            initScrollbar();
        },
        'error': function () {
            console.error('Notifications popup ajax error')
        },
    });
}